import { render, staticRenderFns } from "./TaskNodeConfig.vue?vue&type=template&id=219b3e4c&scoped=true"
import script from "./TaskNodeConfig.vue?vue&type=script&lang=js"
export * from "./TaskNodeConfig.vue?vue&type=script&lang=js"
import style0 from "./TaskNodeConfig.vue?vue&type=style&index=0&id=219b3e4c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219b3e4c",
  null
  
)

export default component.exports